import React, { useRef } from 'react'

const Forecast = ({forecast}) => {

    //console.log(forecast)

    const ref = useRef(null)

    const scroll=(scrollOffset)=>{
        ref.current.scrollX+=scrollOffset
    }

    
    const formatDay = (forecast)=>{
        const d0 = forecast.dt_txt
        const t0 = forecast.dt_txt_t
        const t1 = d0+'T'+t0+'Z'
        const dateForecast = new Date(t1)
        const dayAsNumber = dateForecast.getUTCDay();
        const dateNow = new Date()
        const dayAsNumberLocale = dateNow.getDay()
      
        const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
         return dayAsNumber===dayAsNumberLocale?'Today':days[dayAsNumber]
        //return "Hello"
      
      }
    const formatTime = (date) => {
        const hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        const hoursModified = hours?hours % 12:12;
        //hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesModified = minutes < 10 ? '0'+minutes : minutes;
        const strTime = hoursModified + ':' + minutesModified + ' ' + ampm;
        return strTime;
      }

    const getTime=(forecast) => {
            const d0 = forecast.dt_txt
            const t0 = forecast.dt_txt_t
            const t1 = d0+'T'+t0+'Z'
            const dateForecast = new Date(t1)

            const timeForecast = formatTime(dateForecast)
            
            
            return timeForecast
            
            
    }
  return (
    <>
    <div className="forecast-header">
            {formatDay(forecast[0])}
        </div>
     <div className="forecast-container">
         
        



        { forecast.map((item,index)=>(
    
        <div key={index} className="forecast-component" ref={ref}>
            <div className="forecast-item forecast-time">
            <p>{getTime(item)}</p>
            </div>
            <div className="forecast-item forecast-icon">
            <img src={`https://openweathermap.org/img/w/${item?.weather[0]?.icon}.png`} alt='weathericon'/>
            </div>
            <div className="forecast-item forecast-temp">
            {Math.round(item.main.temp)}°C 
            </div>


        </div>
        
        
         ) ) }
         </div>
    </>
  )
}

export default Forecast